module.exports = __webpack_public_path__ + "img/figma.1549822f.svg";